const e = `.delivery-method[data-v-e00c8bc1]{display:inline-block}
`;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/index.ce.vue3.js
// module id = 1280
// module chunks = 67